import { keyframes } from 'styled-components';

/**
 * Centralized animations — Auge Design System
 * Direction: Operational Sophistication
 *
 * Duration: 150-200ms for micro-interactions, 200ms for reveals.
 * Easing: ease-out (deceleration). No bounce/spring.
 *
 * IMPORTANT: Import from here instead of redefining keyframes in each file.
 * Example: import { fadeIn, spin, pulse } from '~styles/animations';
 */

/** Page/card mount reveal */
export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/** Loading spinner rotation */
export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

/** Skeleton loader breathing */
export const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

/** Skeleton shine effect */
export const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

/** Modal/toast entrance from bottom */
export const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

/** Panel/toast entrance from the right (pairs with horizontal slide-out) */
export const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

/** Drawer/panel entrance from the left (mobile sidebar, etc.) */
export const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

/** Fade out for exit animations */
export const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(10px);
  }
`;
